module.exports = __webpack_public_path__ + "img/wallet.0fe3bb97.svg";